import { __extends } from "tslib";
import RegistryBase from "./registry-base";
var Registry = (function (_super) {
    __extends(Registry, _super);
    function Registry() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Registry;
}(RegistryBase));
export default Registry;
